import React, { useEffect, useState } from 'react';
import Layout from '../../components/auth/layout';
import Form from '../../components/auth/resetPassword';
import { v1_reset_password } from '../../actions/v1/auth';
import swal from 'sweetalert';
import useQuery from '../../customHook/useQuery';

const ResetPasswordPage = () => {
    const [message, setMessage] = useState('');
    const [token, setToken] = useState('');

    const query = useQuery(); // ✅ Correct place to use the hook

    const onReset = (model) => {
        v1_reset_password({ ...model, token }).then(res => {
            if (res.status) {
                setMessage(res.result.message);
            } else {
                swal({
                    title: res.error,
                    icon: 'warning',
                    dangerMode: true,
                });
            }
        });
    };

    useEffect(() => {
        const resetToken = query.get('token');
        if (resetToken) {
            setToken(resetToken);
        } else {
            swal({
                title: 'Invalid or missing token!',
                icon: 'error',
                dangerMode: true,
            });
        }
    }, [query]);

    return (
        <React.Fragment>
            <Layout>
                <Form
                    message={message}
                    onSubmit={onReset}
                />
            </Layout>
        </React.Fragment>
    );
};

export default ResetPasswordPage;
